import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import AssetUploader from '../widgets/AssetUploader';
import AssetBrowser from '../widgets/AssetBrowser';
import { CATEGORIES } from '../../services/fileUpload/uploadFile';
import { clearSbemTrackingHookContentCache } from '../../services/AssetService';
import { checkPermissions } from '../../../lib/utils';
import { ACCESS_POINTS_GROUP } from '../../constants/AccessPoints';

class PagesTracking extends Component {
    onResetErrors = () => {
        this.browser && this.browser.resetErrors();
    };

    onRefresh = () => {
        this.browser && this.browser.refresh();
    };

    onUploadSuccess = () => {
        const { chainId, hotelId } = this.props;
        clearSbemTrackingHookContentCache(chainId, hotelId);
    };

    render() {
        return (
            <div className="ThemeCalendar Theme-Content">
                <h1>Tracking files</h1>
                <hr />
                {this.props.children}
                <AssetBrowser
                    setRef={node => (this.browser = node)}
                    category={CATEGORIES.TRACKING}
                    filter=".+\.(js|css)"
                    displayMode="grid"
                    hasAccessForDelete={this.props.hasAccessTrackingHooks.delete}
                >
                    <div className="col-xs-1">
                        <AssetUploader
                            filter=".+\.(js|css)"
                            onError={error => this.browser && this.browser.errorHandler(error)}
                            onResetErrors={this.onResetErrors}
                            onRefresh={this.onRefresh}
                            onSuccess={this.onUploadSuccess}
                            onOpen={this.onResetErrors}
                            hasAccess={this.props.hasAccessTrackingHooks.add}
                            metadata={{
                                category: CATEGORIES.TRACKING
                            }}
                        />
                    </div>
                </AssetBrowser>
            </div>
        );
    }
}

PagesTracking.propTypes = {
    children: PropTypes.element
};

const mapStateToProps = state => {
    return {
        chainId: state.app.selected.chain.Id,
        hotelId: state.app.selected.selectedHotel.id,
        hasAccessTrackingHooks: checkPermissions(state, ACCESS_POINTS_GROUP.TRACKING_HOOKS)
    };
};

export default connect(mapStateToProps)(PagesTracking);



// WEBPACK FOOTER //
// ./src/components/assets/PagesTracking.js